import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/summer.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';

const TITLE = "Décompte jusqu'à l'Été 2026 - Jours restants jusqu'au début de l'été";
const DESCRIPTION = "Combien de jours restants jusqu'à l'été 2026 ? Quand commence l'été 2026 ? Le décompte jusqu'au début de la saison estivale vous fournit des informations précises sur la date du début de l'été et combien de jours restent.";
const KEYWORDS = "Été 2026, quand commence l'été 2026, date début été 2026, décompte été 2026, combien de jours jusqu'à l'été 2026, début saison estivale 2026";
const OG_URL = "https://do-calculate.com/articles-fr/summer";

function SummerCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const summerStartDate = new Date("2026-06-20T00:00:00");
    const summerEndDate = new Date("2026-09-22T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(summerStartDate));
    const [isSummerStarted, setIsSummerStarted] = useState(new Date() >= summerStartDate);
    const [isSummerEnded, setIsSummerEnded] = useState(new Date() >= summerEndDate);

    useEffect(() => {
        const timer = setTimeout(() => {
            const now = new Date();
            setIsSummerStarted(now >= summerStartDate);
            setIsSummerEnded(now >= summerEndDate);
            if (!isSummerStarted) {
                setTimeLeft(calculateTimeLeft(summerStartDate));
            } else if (!isSummerEnded) {
                setTimeLeft(calculateTimeLeft(summerEndDate));
            }
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, isSummerStarted, isSummerEnded]);

    const summerDates = [
        { name: "Été 2026", start: new Date("2026-06-20T00:00:00"), end: new Date("2026-09-22T00:00:00") },
        { name: "Été 2027", start: new Date("2027-06-21T00:00:00"), end: new Date("2027-09-23T00:00:00") },
        { name: "Été 2028", start: new Date("2028-06-20T00:00:00"), end: new Date("2028-09-22T00:00:00") },
        { name: "Été 2029", start: new Date("2029-06-20T00:00:00"), end: new Date("2029-09-22T00:00:00") },
    ];

    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">
                Décompte jusqu'à l'Été 2026
            </h1>
            <div>
                <BlinkingText
                    text={`Décompte jusqu'au ${isSummerStarted ? 'fin de l\'' : 'début de l\''}été 2026 : l'été 2026 commence le samedi 20/06/2026 et se termine le mardi 22/09/2026.`}
                />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ textAlign: 'center', fontSize: '20px', marginTop: '10px' }}>
                        {isSummerStarted
                            ? (isSummerEnded ? "L'été est terminé pour cette année" : "L'été a commencé !")
                            : "Jusqu'au début de l'été"}
                    </div>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className="p-3 mb-2 bg-success text-white" style={{ fontSize: '28px', textAlign: 'center' }}>
                            Prochaines dates de l'été
                        </h2>
                        <table style={{ fontSize: '18px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '12px', borderBottom: '2px solid #ccc' }}>Saison</th>
                                    <th style={{ padding: '12px', borderBottom: '2px solid #ccc' }}>Début</th>
                                    <th style={{ padding: '12px', borderBottom: '2px solid #ccc' }}>Fin</th>
                                    <th style={{ padding: '12px', borderBottom: '2px solid #ccc' }}>Jours restants</th>
                                </tr>
                            </thead>
                            <tbody>
                                {summerDates.map((item, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '10px' }}>{item.name}</td>
                                        <td style={{ padding: '10px' }}>{item.start.toLocaleDateString('fr-FR')}</td>
                                        <td style={{ padding: '10px' }}>{item.end.toLocaleDateString('fr-FR')}</td>
                                        <td style={{ padding: '10px' }}>{Math.max(0, calculateTimeLeft(item.start).days ?? 0)} jours</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-4 col-md-4">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Décompte jusqu'à l'Été 2026</h3>
                    <p>
                        Dans cet article, nous vous proposons un décompte détaillé jusqu'à l'été, afin que vous puissiez être informé à tout moment du nombre de jours restants jusqu'au début ou à la fin de cette saison. Beaucoup d'entre nous se demandent combien de jours restent jusqu'à l'été. C'est pourquoi, dans cet article, nous vous présentons le décompte jusqu'à l'été.
                    </p>
                    <p>
                        L'été 2026 commence le samedi 20/06/2026 (solstice d'été) et se termine le mardi 22/09/2026 (équinoxe d'automne). Vous pouvez voir le décompte jusqu'à l'été dans cet article.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className="p-3 mb-2 bg-success text-white">
                        Calculer les jours restants jusqu'à l'été
                    </h3>
                    <p>
                        Grâce au programme de décompte de l'été, vous pouvez savoir combien de jours restent jusqu'au début ou à la fin de la saison estivale. Profitez de ce décompte pour planifier vos vacances et vos activités d'été.
                    </p>
                    <h3 className="p-3 mb-2 bg-success text-white">L'été</h3>
                    <p>
                        L'été est l'une des quatre saisons de l'année, caractérisé par des températures élevées, des journées longues et des nuits courtes. Dans l'hémisphère nord, l'été commence le 20 ou 21 juin (solstice d'été) et se termine le 22 ou 23 septembre (équinoxe d'automne). L'été est la saison des vacances, des plages et des festivals en plein air.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="Décompte jusqu'à l'été 2026"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default SummerCountdown;
